import { createFileRoute } from '@tanstack/react-router';
import { CaptureOverviewPage } from '@web/modules/capture/overview/capture-overview-page';

export const Route = createFileRoute('/_app/capture/')({
  component: CaptureOverviewPage,
});
